import _ from "lodash";
import { useCallback, useReducer } from "react";
import { ViewOptionStateEnum } from "../../contextual-app-bar/ViewOptionStateEnum";

export enum MessagingTypeEnum {
    Default = 0,
    Custom = 1
}

export type AlarmSetpointMessagingStateType = {
    messagingType: MessagingTypeEnum;
    viewOptionState: ViewOptionStateEnum;
};

enum AlarmSetpointMessagingActionType {
    MessagingTypeChanged = "MESSAGING_TYPE_CHANGED",
    ResetChanged = "RESET_CHANGED",
}

type AlarmSetpointMessagingAction = {
    type: AlarmSetpointMessagingActionType.MessagingTypeChanged;
    payload: MessagingTypeEnum;
} | {
    type: AlarmSetpointMessagingActionType.ResetChanged;
    payload: void;
};

const initialState: AlarmSetpointMessagingStateType = {
    messagingType: MessagingTypeEnum.Default,
    viewOptionState: ViewOptionStateEnum.Default
};

const optionsChanged = (newState: AlarmSetpointMessagingStateType, 
    defaultState: AlarmSetpointMessagingStateType) => 
    newState.messagingType !== defaultState.messagingType;

function setpointMessagingReducer(state: AlarmSetpointMessagingStateType, action: AlarmSetpointMessagingAction): AlarmSetpointMessagingStateType {
    let copy = _.cloneDeep(state);    

    switch (action.type) {

        case AlarmSetpointMessagingActionType.MessagingTypeChanged:
            copy.messagingType = action.payload;
            break;

                
        case AlarmSetpointMessagingActionType.ResetChanged:
            copy = _.cloneDeep(initialState);
            break;

        default:
            return state;
    }

    copy.viewOptionState = optionsChanged(copy, initialState) ? 
                            ViewOptionStateEnum.Changed : 
                            ViewOptionStateEnum.Default;

    return copy;
}

export type UseAlarmSetpointMessagingStateType = {
    state: AlarmSetpointMessagingStateType;
    setMessagingType: (value: MessagingTypeEnum) => void;
    resetState: () => void;
};

export function useAlarmSetpointMessagingState(): UseAlarmSetpointMessagingStateType {

    const [state, dispatch] = useReducer(setpointMessagingReducer, initialState);

    
    const setMessagingType = useCallback((value: MessagingTypeEnum) => dispatch({
        type: AlarmSetpointMessagingActionType.MessagingTypeChanged,
        payload: value
    }), []);


    const resetState = useCallback(() => dispatch({
        type: AlarmSetpointMessagingActionType.ResetChanged,
        payload: undefined
    }), [])

    return {
        state,
        setMessagingType,
        resetState
    };
}
